import cx from 'classnames';
import {useEffect, useState} from 'react';
import {Spinner} from '~/common/components/Loader/Spinner';
import {useIsMediumAndUp} from '~/common/hooks/useMatchQuery';
import {Typography} from '~library/atoms/Typography';
import {PhotoGalleryIcon} from '~library/svg/PhotoGalleryIcon';
import {white} from '~libSass/base/_exports.sass';

import './PhotosModuleTile.sass';

export const ViewAllOverlay = ({isMediumAndUp}) => (
  <div className="photos__dark-overlay photos__view-gallery-overlay">
    <PhotoGalleryIcon color={white} />
    <Typography variant={isMediumAndUp ? 'paragraph1' : 'paragraph3'} color="white">
      View All
    </Typography>
  </div>
);

export const PhotosModuleTile = ({
  idx,
  id,
  url,
  width = null,
  height = null,
  length,
  isHostModule = false,
  getThumbnailUrl,
  onViewGallery,
  onViewPhotoFn,
  hasRadius = false,
  isViewAll = false,
}) => {
  const [loading, setLoading] = useState(true);
  const isMediumAndUp = useIsMediumAndUp();
  const isFeatured = idx === 0 && isHostModule && length !== 2;

  useEffect(() => {
    const img = new Image();
    img.src = getThumbnailUrl(url);
    img.onload = () => {
      setLoading(false);
    };
  }, [getThumbnailUrl, url]);

  const aspectRatio = (index) => {
    if (!isHostModule) return 1;
    if (length === 2) return null;
    if (index === 0) {
      const ar = width / height;
      return Math.min(Math.max(ar, 1), 1.33);
    }
    return isMediumAndUp ? 1.33 : 1;
  };

  return (
    <button
      type="button"
      data-qa-id="button-view-single-photo"
      className={cx('photo__tile-button', {
        'photo__tile-button-featured': isFeatured,
        'photo__tile-button-with-radius': hasRadius,
      })}
      onClick={isViewAll ? onViewGallery : onViewPhotoFn(id)}
      title={idx === length - 1 ? 'Click to open gallery' : 'Click to view image'}
      style={{
        aspectRatio: aspectRatio(idx),
        backgroundImage: `url(${getThumbnailUrl(url)})`,
      }}
    >
      {loading && (
        <div className="photos__dark-overlay">
          <Spinner />
        </div>
      )}
      {isViewAll && <ViewAllOverlay isMediumAndUp={isMediumAndUp} />}
    </button>
  );
};
